module.exports = __webpack_public_path__ + "img/600.a5b74c5e.svg";